import {ApplicationRef, ComponentFactoryResolver, ComponentRef, inject, Injectable, Injector} from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
    private resolver = inject(ComponentFactoryResolver);
    private injector = inject(Injector);
    private appRef = inject(ApplicationRef);

  private sidenav: MatSidenav;
  private componentRef: ComponentRef<any>;

  // Register the sidenav
  registerSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  // Open a component in the sidenav
  open(component: any, data?: any) {
    if (this.sidenav.opened) {
      this.close();
    }

    const factory = this.resolver.resolveComponentFactory(component);
    this.componentRef = factory.create(this.injector);

    // Pass data to the component if needed
    if (data) {
      Object.assign(this.componentRef.instance, data);
    }

    this.appRef.attachView(this.componentRef.hostView);

    // clear existing childs on sidenav content
    this.sidenav._content.nativeElement.innerHTML = '';

    const domElem = (this.componentRef.hostView as any).rootNodes[0] as HTMLElement;
    this.sidenav._content.nativeElement.appendChild(domElem);

    this.sidenav.open();
  }

  // Close the sidenav and destroy the component
  close() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
    this.sidenav.close();
  }
}
